<template>
  <div
    :class="{'aside-is-collapsed': collapse}"
    class="flex flex-col h-full">
      <header-core />
      <div class="flex h-full overflow-hidden relative">
        <aside-core :isOpen="aside" @toggle="asideBehaviour" @toogleAside="toogleAside"/>
        <router-view />
        <div class="absolute left-0 bottom-0 z-20 lg:hidden">
          <div class="pl-4 py-2 md:py-1">
            <base-button-icon
              @click="toogleAside"
              name="hamburguer" mode="primary-phantom" size="xl" />
          </div>
        </div>
      </div>
  </div>
</template>
<script>
import HeaderCore from '@/components/HeaderCore.vue'
import AsideCore from '@/components/AsideCore.vue'
export default {
  name: 'private-home',
  components: {
    HeaderCore,
    AsideCore
  },
  data: function () {
    return {
      aside: false,
      collapse: false
    }
  },
  mounted: function () {
    if (document.body.classList.contains('static-css')) {
      document.body.classList.remove('static-css')
    }
  },
  methods: {
    toogleAside: function () {
      this.aside = !this.aside
    },
    asideBehaviour: function (res) {
      this.aside = res.aside
      this.collapse = res.collapse
      // this.collapsed = response.collapse
    }
  }
}
</script>
<style lang="scss" scoped></style>
